import { Network } from '@tonappchain/sdk';
import { defineChain } from 'viem';

// TAC 链配置
export const tacTestnet = defineChain({
  id: 2391,
  name: 'TAC SPB',
  network: 'tac',
  nativeCurrency: {
    decimals: 18,
    name: 'TAC',
    symbol: 'TAC'
  },
  rpcUrls: {
    default: {
      http: ['https://spb.rpc.tac.build']
    },
    public: {
      http: ['https://spb.rpc.tac.build']
    }
  },
  blockExplorers: {
    default: {
      name: 'TAC Explorer',
      url: 'https://spb.explorer.tac.build'
    }
  }
});

// export const tacTestnet = defineChain({
//   id: 2391,
//   name: 'TAC SPB',
//   network: 'tac',
//   nativeCurrency: {
//     decimals: 18,
//     name: 'TAC',
//     symbol: 'TAC'
//   },
//   rpcUrls: {
//     default: {
//       http: ['http://34.203.126.155:8545']
//     },
//     public: {
//       http: ['http://34.203.126.155:8545']
//     }
//   },
//   blockExplorers: {
//     default: {
//       name: 'TAC Explorer',
//       url: 'https://spb.explorer.tac.build'
//     }
//   }
// });

export const tacMainnet = defineChain({
  id: 239,
  name: 'TAC Mainnet',
  rpcUrls: {
    default: {
      http: ['https://rpc.tac.build']
    },
    public: {
      http: ['https://rpc.tac.build']
    }
  },
  nativeCurrency: {
    name: 'TAC',
    symbol: 'TAC',
    decimals: 18
  },
  blockExplorers: {
    default: {
      name: 'TAC Explorer',
      url: 'https://explorer.tac.build'
    }
  },
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11'
    }
  }
});
export const ENVS = {
  // WALLET_CONNECT_PROJECT_ID: import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID,
  // CHAIN_ENV: import.meta.env.VITE_CHAIN_ENV,
  // TAC_VESTING_CONTRACT_ADDRESS: '0x76568eDcEdc96B928CF2309E4D327168b38d25CD',
  TAC_CHAIN: tacMainnet,
  TAC_NETWORK: Network.MAINNET,
  TAC_VESTING_CONTRACT_ADDRESS: '0xFf8FCb371f611bF3e5e8Ff57c951988bD1d3ee86', //'0x2955c08288ADe7ec6F71c0499cE6E30921ba3DA0'
  TAC_DISTRIBUTION_CONTRACT_ADDRESS: '0x0000000000000000000000000000000000000801',
  TAC_STAKING_CONTRACT_ADDRESS: '0x0000000000000000000000000000000000000800',
  // TAC_VALIDATOR_ADDRESS: 'tacvaloper15lvhklny0khnwy7hgrxsxut6t6ku2cgkwu9tyt'
  TAC_VALIDATOR_ADDRESS: 'tacvaloper10q6xlum6mz6ndn54280wt5phqkxcsqcqnmmu98',
  startTime: '2025-07-15 10:00 UTC',
  endTime: '2025-12-15 11:59 UTC',
  TERM_OF_USE: 'https://ethsign.notion.site/Terms-613f94dd3a754d5aa4fd4bbe9a10ff3a',
  // ENV: import.meta.env.VITE_ENV,
  CommunityUrl: 'https://t.me/+3V-X6b9VEHgzZmNl'
};
